(function () {
  const MOBILE_QUERY = '(max-width: 768px)';

  const getActiveVideo = (section) => {
    const videos = section.querySelectorAll('.hero-video__video');
    if (videos.length === 0) return null;

    return (
      Array.from(videos).find((video) => video.offsetParent !== null) || videos[0]
    );
  };

  const initPlayback = (section) => {
    const btn = section.querySelector('.hero-video__pause');
    if (!btn) return;

    const toggle = () => {
      const video = getActiveVideo(section);
      if (!video || typeof video.play !== 'function') return;

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    };

    const syncButton = () => {
      const video = getActiveVideo(section);
      if (!video) return;
      btn.setAttribute('aria-pressed', String(video.paused));
    };

    btn.addEventListener('click', toggle);

    section.querySelectorAll('.hero-video__video').forEach((video) => {
      if (typeof video.play !== 'function') return;
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
    });
  };

  const initLogosMarquee = (section) => {
    const track = section.querySelector('.hero-video__logos-track');
    if (!track || track.dataset.marqueeReady === 'true') return;

    const mq = window.matchMedia(MOBILE_QUERY);
    if (!mq.matches) return;

    const originals = Array.from(track.children);
    if (originals.length === 0) return;

    originals.forEach((logo) => {
      const clone = logo.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.dataset.marqueeReady = 'true';
  };

  const initLoader = (section) => {
    const media = section.querySelector('.hero-video__media');
    if (!media || !media.classList.contains('is-loading')) return;

    const hideLoader = () => media.classList.remove('is-loading');

    const video = getActiveVideo(section);
    if (!video) {
      hideLoader();
      return;
    }

    // HAVE_FUTURE_DATA or more: video is already ready to play.
    if (video.readyState >= 3) {
      hideLoader();
      return;
    }

    video.addEventListener('canplay', hideLoader, { once: true });
    video.addEventListener('playing', hideLoader, { once: true });
    video.addEventListener('error', hideLoader, { once: true });
  };

  const init = (section) => {
    initPlayback(section);
    initLoader(section);
    initLogosMarquee(section);

    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => initLogosMarquee(section);
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
  };

  document.querySelectorAll('.hero-video').forEach(init);
})();
